import bnc from "bnc";
const block = new bnc('social_icon');


export {
    block
};
